var map = {
	"./flag_American.svg": [
		1275,
		275
	],
	"./flag_British.svg": [
		9010,
		10
	],
	"./flag_Canadian.svg": [
		3940,
		940
	],
	"./flag_Chinese.svg": [
		2354,
		354
	],
	"./flag_Dutch.svg": [
		3519,
		519
	],
	"./flag_Egyptian.svg": [
		4659,
		659
	],
	"./flag_French.svg": [
		3560,
		560
	],
	"./flag_Greek.svg": [
		7952,
		952
	],
	"./flag_Indian.svg": [
		8514,
		514
	],
	"./flag_Irish.svg": [
		8568,
		568
	],
	"./flag_Italian.svg": [
		5897,
		897
	],
	"./flag_Jamaican.svg": [
		807,
		807
	],
	"./flag_Japanese.svg": [
		4679,
		679
	],
	"./flag_Kenyan.svg": [
		4400,
		400
	],
	"./flag_Malaysian.svg": [
		1238,
		238
	],
	"./flag_Mexican.svg": [
		8939,
		939
	],
	"./flag_Moroccan.svg": [
		8268,
		268
	],
	"./flag_Polish.svg": [
		7457,
		882
	],
	"./flag_Russian.svg": [
		5423,
		423
	],
	"./flag_Spanish.svg": [
		9242,
		242
	],
	"./flag_Thai.svg": [
		4457,
		457
	],
	"./flag_Tunisian.svg": [
		737,
		737
	],
	"./flag_Turkish.svg": [
		4173,
		173
	],
	"./flag_Vietnamese.svg": [
		7405,
		405
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => Object.keys(map);
webpackAsyncContext.id = 135;
module.exports = webpackAsyncContext;